import React, { useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePermission } from '../contexts/PermissionContext';
import logoMapGroup from '../logo-map-group.png';
import './Navigation.css';

function Navigation() {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuth();
    const { canAccessSection } = usePermission();

    // 관리자 역할 확인
    const isAdmin = user?.role === 'super_admin' || user?.role === 'admin';

    // 전체 메뉴 항목 (섹션 이름과 매핑)
    const allMenuItems = [
        { id: 'vision', label: '비전', path: '/vision', icon: '🎯', sectionName: '비전' },
        { id: 'recognition', label: '인정', path: '/recognition', icon: '⭐', sectionName: '인정' },
        { id: 'reward', label: '보상', path: '/reward', icon: '🏆', sectionName: '보상' },
        { id: 'education', label: '교육', path: '/education', icon: '📚', sectionName: '교육' },
        { id: 'overview', label: '전체보기', path: '/overview', icon: '📊', sectionName: null }, // 전체보기는 섹션 권한 체크 안함
    ];

    // 권한 기반 메뉴 필터링
    const menuItems = useMemo(() => {
        const filteredItems = isAdmin
            ? allMenuItems
            : allMenuItems.filter(item =>
                item.sectionName === null || canAccessSection(item.sectionName)
            );

        // 관리자 메뉴 추가 (admin/super_admin만)
        if (isAdmin) {
            filteredItems.push({ id: 'admin', label: '관리자', path: '/admin', icon: '⚙️' });
        }

        return filteredItems;
    }, [isAdmin, canAccessSection]);

    const handleLogoClick = () => {
        navigate('/main');
    };

    const handleMenuClick = (path) => {
        navigate(path);
    };

    return (
        <nav className="top-navigation">
            <div className="nav-container">
                {/* 로고 영역 */}
                <div className="nav-logo" onClick={handleLogoClick}>
                    <img src={logoMapGroup} alt="MAP GROUP" className="nav-logo-image" />
                    <p className="nav-logo-subtitle">METARICH AI PATH</p>
                </div>

                {/* 메뉴 탭 영역 */}
                <div className="nav-menu">
                    {menuItems.map((item) => (
                        <button
                            key={item.id}
                            className={`nav-menu-item ${location.pathname === item.path ? 'active' : ''} ${item.id === 'admin' ? 'admin-btn' : ''}`}
                            onClick={() => handleMenuClick(item.path)}
                        >
                            {item.label}
                        </button>
                    ))}
                </div>
            </div>
        </nav>
    );
}

export default Navigation;
